module.exports = __webpack_public_path__ + "img/expert-elena.ac46a5f0.png";